module.exports = __webpack_public_path__ + "img/screenshot1.bcb31be1.png";